(() => {
  if (window.__myromyCollectionColorEnhancerV1) return;
  window.__myromyCollectionColorEnhancerV1 = true;

  const editionPaths = new Set([
    '/collections/signature-edition-kochkeramik',
    '/collections/coffee-edition-kochkeramik',
    '/collections/cream-edition-kochkeramik'
  ]);

  const worlds = [
    { key:'signature', label:'Signature', color:'#B7663F', aliases:['signature','terrakotta','terracotta','naturton'] },
    { key:'coffee', label:'Coffee', color:'#49332C', aliases:['coffee'] },
    { key:'cream', label:'Cream', color:'#EEE6D8', aliases:['cream','weiß','weiss'] }
  ];

  let raf = 0;

  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  })[character]);

  const localizedEditionFallback = () => {
    const locale = String(document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    const copy = {
      de: { eyebrow:'Deine Farbwelt', title:'Edition wechseln', switcherAria:'Farbwelt wechseln', facetAria:'Farbwelt wählen' },
      en: { eyebrow:'Your colour world', title:'Switch edition', switcherAria:'Switch colour world', facetAria:'Choose colour world' },
      fr: { eyebrow:'Votre univers de couleurs', title:'Changer d’édition', switcherAria:'Changer d’univers de couleurs', facetAria:'Choisir un univers de couleurs' },
      nl: { eyebrow:'Jouw kleurwereld', title:'Van editie wisselen', switcherAria:'Kleurwereld wisselen', facetAria:'Kleurwereld kiezen' },
      it: { eyebrow:'La tua palette', title:'Cambia edizione', switcherAria:'Cambia palette', facetAria:'Scegli palette' },
      lb: { eyebrow:'Deng Faarfwelt', title:'Editioun wiesselen', switcherAria:'Faarfwelt wiesselen', facetAria:'Faarfwelt auswielen' },
      sv: { eyebrow:'Din färgvärld', title:'Byt edition', switcherAria:'Byt färgvärld', facetAria:'Välj färgvärld' }
    };
    return copy[locale] || copy.en;
  };

  const editionUi = () => {
    const config = document.getElementById('myromy-edition-switcher-config');
    const fallback = localizedEditionFallback();
    return {
      eyebrow: config?.dataset.eyebrow || fallback.eyebrow,
      title: config?.dataset.title || fallback.title,
      switcherAria: config?.dataset.switcherAria || fallback.switcherAria,
      facetAria: config?.dataset.facetAria || fallback.facetAria
    };
  };

  const cleanPath = () => window.location.pathname.replace(/\/+$/, '') || '/';
  const isEditionPage = () => editionPaths.has(cleanPath());
  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const identifyWorld = (value) => {
    const text = normalise(value);
    return worlds.find((world) => world.aliases.some((alias) => text.includes(alias))) || null;
  };

  const isColorDetails = (details) => {
    const content = details?.querySelector(':scope > .accordion__content') || details;
    const list = content?.querySelector('.color-list');
    if (!list) return false;
    const seen = new Set();
    list.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      const label = input.id ? list.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      const world = identifyWorld(`${label?.textContent || ''} ${input.value || ''}`);
      if (world) seen.add(world.key);
    });
    return seen.size >= 2;
  };

  const getEntries = (details) => {
    const content = details?.querySelector(':scope > .accordion__content') || details;
    const list = content?.querySelector('.color-list');
    if (!list) return { list:null, entries:[] };

    const seen = new Set();
    const entries = Array.from(list.querySelectorAll('input[type="checkbox"]')).map((input) => {
      const label = input.id ? list.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
      const world = identifyWorld(`${label?.textContent || ''} ${input.value || ''}`);
      if (!world || seen.has(world.key)) return null;
      seen.add(world.key);
      return { input, world };
    }).filter(Boolean);

    return { list, entries };
  };

  const activeKey = (entries) => entries.find((entry) => entry.input.checked)?.world.key || '';

  const selectWorld = (entries, key) => {
    const target = entries.find((entry) => entry.world.key === key);
    if (!target) return;

    const name = target.input.name;
    const value = target.input.value;

    if (!name || !value) {
      target.input.click();
      return;
    }

    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    url.searchParams.set(name, value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  };

  const dotMarkup = (world) => `<span class="mse-edition-dot" style="--mse-edition-color:${world.color}" aria-hidden="true"></span>`;

  const updateTopState = (nav, entries) => {
    const current = activeKey(entries);
    nav.querySelectorAll('[data-myromy-native-color]').forEach((link) => {
      if (link.dataset.myromyNativeColor === current) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const mountTopSwitcher = (section, entries) => {
    if (!section || entries.length < 2) return;

    let nav = section.querySelector('[data-myromy-native-color-switcher]');
    const sourceInput = entries[0].input;

    if (nav && nav.__myromyNativeSource !== sourceInput) {
      nav.remove();
      nav = null;
    }

    if (!nav) {
      nav = document.createElement('nav');
      nav.className = 'mse-edition-switcher';
      nav.dataset.myromyNativeColorSwitcher = 'true';
      const ui = editionUi();
      nav.setAttribute('aria-label', ui.switcherAria);
      nav.innerHTML = `<div class="mse-edition-switcher__panel"><div class="mse-edition-switcher__head"><span class="mse-edition-switcher__eyebrow">${escapeHtml(ui.eyebrow)}</span><span class="mse-edition-switcher__title">${escapeHtml(ui.title)}</span></div><div class="mse-edition-switcher__track">${entries.map((entry) => `<a class="mse-edition-switcher__chip" href="#" data-myromy-native-color="${entry.world.key}">${dotMarkup(entry.world)}<span>${entry.world.label}</span></a>`).join('')}</div></div>`;
      nav.__myromyNativeSource = sourceInput;

      nav.addEventListener('click', (event) => {
        const link = event.target.closest('[data-myromy-native-color]');
        if (!link) return;
        event.preventDefault();
        const currentDetails = findPrimaryColorDetails();
        const currentEntries = currentDetails ? getEntries(currentDetails).entries : [];
        selectWorld(currentEntries, link.dataset.myromyNativeColor);
      });

      const container = section.querySelector('.container');
      if (container) container.insertBefore(nav, container.firstElementChild);
      else section.insertBefore(nav, section.firstElementChild);
    }

    updateTopState(nav, entries);
  };

  const updateFacetState = (picker, entries) => {
    const current = activeKey(entries);
    picker.querySelectorAll('[data-myromy-native-color]').forEach((link) => {
      if (link.dataset.myromyNativeColor === current) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  };

  const mountFacetPicker = (details, list, entries) => {
    if (!details || !list || entries.length < 2) return;
    list.hidden = true;

    const content = details.querySelector(':scope > .accordion__content') || details;
    let picker = content.querySelector('[data-myromy-native-color-facet]');
    const sourceInput = entries[0].input;

    if (picker && picker.__myromyNativeSource !== sourceInput) {
      picker.remove();
      picker = null;
    }

    if (!picker) {
      picker = document.createElement('nav');
      picker.className = 'mse-edition-facet';
      picker.dataset.myromyNativeColorFacet = 'true';
      picker.setAttribute('aria-label', editionUi().facetAria);
      picker.innerHTML = entries.map((entry) => `<a class="mse-edition-facet__option" href="#" data-myromy-native-color="${entry.world.key}">${dotMarkup(entry.world)}<span>${entry.world.label}</span></a>`).join('');
      picker.__myromyNativeSource = sourceInput;

      picker.addEventListener('click', (event) => {
        const link = event.target.closest('[data-myromy-native-color]');
        if (!link) return;
        event.preventDefault();
        const liveEntries = getEntries(details).entries;
        selectWorld(liveEntries, link.dataset.myromyNativeColor);
      });

      content.insertBefore(picker, content.firstChild);
      details.open = true;
      details.setAttribute('aria-expanded', 'true');
    }

    updateFacetState(picker, entries);
  };

  const getColorDetails = () => Array.from(document.querySelectorAll('details.accordion')).filter(isColorDetails);

  const findPrimaryColorDetails = () => {
    const vertical = Array.from(document.querySelectorAll('.facets-vertical details.accordion')).find((details) => {
      const { entries } = getEntries(details);
      return isColorDetails(details) && entries.length >= 2;
    });
    if (vertical) return vertical;
    return getColorDetails().find((details) => getEntries(details).entries.length >= 2) || null;
  };

  const enhance = () => {
    if (isEditionPage()) return;

    const detailsList = getColorDetails();
    let primary = null;

    detailsList.forEach((details) => {
      const { list, entries } = getEntries(details);
      if (!list || entries.length < 2) return;
      mountFacetPicker(details, list, entries);
      if (!primary && details.matches('.facets-vertical details.accordion')) primary = { details, entries };
      if (!primary) primary = { details, entries };
    });

    if (!primary) return;
    const section = document.querySelector('.shopify-section--main-collection') || primary.details.closest('.shopify-section');
    mountTopSwitcher(section, primary.entries);
  };

  const schedule = () => {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      raf = 0;
      enhance();
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('details.accordion input[type="checkbox"]')) schedule();
  });

  new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) return;
    schedule();
  }).observe(document.body, { childList:true, subtree:true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once:true });
  else enhance();

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:select', schedule);
})();
